import React from "react";
import PropTypes from "prop-types";
import TextInput from "../../common/TextInput";
import AdresFormItem from "./AdresFormItem";
import Fieldset from "../../common/Fieldset";
import NumberInput from "../../common/NumberInput";
import Row from "../../common/Row";

const HoofdzetelFormItem = (props) => {
    const { model,
        onChange,
        onChangeHoofdzetelAdres,
        errors
    } = props;

    return (
        <Fieldset title="Hoofdzetel">
            <Row>
                <NumberInput
                    name="ondernemingsnummer"
                    label="Ondernemingsnummer"
                    value={model.ondernemingsnummer}
                    originalValue={model.ondernemingsnummer}
                    dontParse
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['ondernemingsnummer'] : ""}
                />
                <TextInput
                    name="bedrijfnaam"
                    label="Naam bedrijf"
                    value={model.bedrijfnaam}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['bedrijfnaam'] : ""}
                />
            </Row>

            <Row>
                <TextInput
                    name="emailBedrijf"
                    label="E-mailadres bedrijf"
                    value={model.emailBedrijf}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['emailBedrijf'] : ""}
                />
            </Row>
            

            <AdresFormItem
                model={model.adres}
                onChange={onChangeHoofdzetelAdres}
                errors={errors}
            />
        </Fieldset>
    );
};



HoofdzetelFormItem.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func,
    onChangeHoofdzetelAdres: PropTypes.func,
    errors: PropTypes.array
};

export default HoofdzetelFormItem;